"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentLink = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const useLangContext_1 = require("../../../../hooks/useLangContext");
const buildAnalyticUrl_1 = require("../../../../utils/buildAnalyticUrl");
const Text_1 = __importDefault(require("../../../_core/Text"));
const locales_1 = require("./locales");
const PaymentLink = (invoice) => {
    const { syncLocales } = (0, useLangContext_1.useLangContext)();
    syncLocales(locales_1.locales);
    const publicPaymentUrl = (0, buildAnalyticUrl_1.buildAnalyticUrl)(invoice.publicPaymentUrl, {
        utmMedium: 'link',
        utmSource: 'pdf',
    });
    return (react_2.default.createElement(Text_1.default, { borderTop: "1px solid", borderTopColor: "grey.300", fontWeight: "weight-500", padding: "space-8" },
        locales_1.locales.beforeText,
        react_2.default.createElement(react_1.Link, { color: "blue.600", href: publicPaymentUrl, target: "_blank", textDecorationLine: "underline" }, locales_1.locales.linkText),
        locales_1.locales.afterText));
};
exports.PaymentLink = PaymentLink;
